var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{style:({ maxWidth: _vm.maxWidth }),attrs:{"id":"production-summary-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }